import { Injectable, inject } from '@angular/core';
import type { CanDeactivateFn } from '@angular/router';
import { AppolowModal } from '@appolow/modal';

@Injectable({
	providedIn: 'root'
})
class ModalGuard {
	#modalSvc = inject(AppolowModal);

	canDeactivate(): boolean {
		return !this.#modalSvc.hasOpenModals();
	}
}

export const modalGuard: CanDeactivateFn<boolean> = () => {
	const guard = inject(ModalGuard);

	return guard.canDeactivate();
};
